/*

    constructor(props) {
        super(props);
        var state = {
            allSongs: this.getData(),
            set1Songs: this.getSet1Data(),
            set2Songs: this.getSet2Data(),
            set3Songs: this.getSet3Data(),
            encoreSongs: this.getSet4Data(),
            artists: this.getArtists(),
            songs: this.getSongs()
        };
        this.state = state;
    }

*/

function getData() {
    // sort by song title
    function compareSong(a: SongData, b: SongData) {
        if (a.songTitle < b.songTitle) {
            return -1;
        }
        if (a.songTitle > b.songTitle) {
            return 1;
        }
        return 0;
    }

    return music.sort(compareSong);
}

function getSetData(x: number) {
    function compareSetOrder(a: SongData, b: SongData) {
        if (a.songNumber < b.songNumber) {
            return -1;
        }
        if (a.songNumber > b.songNumber) {
            return 1
        }
        return 0;
    }

    return music.filter(song => song.set === x).sort(compareSetOrder);
}

// eslint-disable-next-line
function getSet1Data() {
    return getSetData(1);
}

// eslint-disable-next-line
function getSet2Data() {
    return getSetData(2);
}

// eslint-disable-next-line
function getSet3Data() {
    return getSetData(3);
}

// eslint-disable-next-line
function getSet4Data() {
    return getSetData(4);
}

// eslint-disable-next-line
function getArtists() {
    return music.map(song => song.artist);
}

// eslint-disable-next-line
function getSongTitles() {
    return music.map(song => song.songTitle)
}

// Note: To update thumbnails, go to https://archive.org/ (the Internet Archive) search for the album name, go to the files and find the thumb

var music: SongData[] = [
    {
        id: 35,
        songTitle: "Fairies Wear Boots",
        artist: "Black Sabbath",
        set: 4,
        songNumber: 3,
        imageUrl: "Black Sabbath @ The Filmore West 27-11-1970_thumb.jpg",
        description: ""
    }, {
        id: 34,
        songTitle: "Rock and Roll All Nite",
        artist: "Kiss",
        set: 4,
        songNumber: 2,
        imageUrl: "1-booklet 01_thumb.jpg",
        description: ""
    }, {
        id: 33,
        songTitle: "Let's Go Crazy",
        artist: "Prince",
        set: 4,
        songNumber: 1,
        imageUrl: "91F04uhP7vL._SL1500__thumb.jpg",
        description: ""
    }, {
        id: 32,
        songTitle: "Whiskey in the Jar",
        artist: "Metallica",
        set: 3,
        songNumber: 9,
        imageUrl: "mbid-7f5a52aa-4429-4771-80ec-6c6a545b0df9-11162732155_thumb250.jpg",
        description: ""
    }, {
        id: 31,
        songTitle: "Sex Type Thing",
        artist: "Stone Temple Pilots",
        set: 2,
        songNumber: 8,
        imageUrl: "__ia_thumb-7.jpg",
        description: ""
    }, {
        id: 30,
        songTitle: "Surrender",
        artist: "Cheap Trick",
        set: 3,
        songNumber: 7,
        imageUrl: "__ia_thumb-11.jpg",
        description: ""
    }, {
        id: 29,
        songTitle: "Rock This Town",
        artist: "The Stray Cats",
        set: 3,
        songNumber: 6,
        imageUrl: "__ia_thumb-10.jpg",
        description: ""
    }, {
        id: 28,
        songTitle: "Basket Case",
        artist: "Green Day",
        set: 3,
        songNumber: 5,
        imageUrl: "mbid-20fef8d3-72b5-369a-9712-ad0b1ee6d226-7378765590_thumb250.jpg",
        description: ""
    }, {
        id: 27,
        songTitle: "Ahead by a Century",
        artist: "The Tragically Hip",
        set: 3,
        songNumber: 6,
        imageUrl: "mbid-6966ed5b-696a-4252-92dd-79e7e3057d44-14452429537_thumb250.jpg",
        description: ""
    }, {
        id: 26,
        songTitle: "Wild Flower",
        artist: "The Cult",
        set: 3,
        songNumber: 4,
        imageUrl: "__ia_thumb-13.jpg",
        description: ""
    }, {
        id: 25,
        songTitle: "Mrs. Robinson",
        artist: "The Lemonheads",
        set: 3,
        songNumber: 2,
        imageUrl: "mbid-8113c075-e1ae-3b92-a598-593ada98f0bc-15193189798_thumb250.jpg",
        description: ""
    }, {
        id: 24,
        songTitle: "Come Together",
        artist: "The Beatles",
        set: 3,
        songNumber: 1,
        imageUrl: "mbid-ffd6ebf5-10c1-3cca-915e-04c0aba926f3-1761175461_thumb250.jpg",
        description: ""
    }, {
        id: 23,
        songTitle: "I Wanna Be Sedated",
        artist: "The Ramones",
        set: 1,
        songNumber: 12,
        imageUrl: "mbid-1f40b8b2-dd27-4554-8e64-0139a6b5bb39-6803023814_thumb250.jpg",
        description: ""
    }, {        
        id: 22,
        songTitle: "White Wedding",
        artist: "Billy Idol",
        set: 2,
        songNumber: 12,
        imageUrl: "mbid-0d254a8b-9be5-4019-a444-860b1da0a339-10932678034_thumb250.jpg",
        description: ""
    }, {
        id: 21,
        songTitle: "Whip It",
        artist: "Devo",
        set: 2,
        songNumber: 12,
        imageUrl: "__ia_thumb-14.jpg",
        description: ""
    }, {
        id: 20,
        songTitle: "Song 2",
        artist: "Blur",
        set: 2,
        songNumber: 11,
        imageUrl: "Blur Cover_thumb.jpg",
        description: ""
    }, {
        id: 19,
        songTitle: "Fly Away",
        artist: "Lenny Kravitz",
        set: 2,
        songNumber: 10,
        imageUrl: "__ia_thumb-2.jpg",
        description: ""
    }, {
        id: 18,
        songTitle: "White Room",
        artist: "Cream",
        set: 2,
        songNumber: 9,
        imageUrl: "__ia_thumb-12.jpg",
        description: ""
    }, {
        id: 17,
        songTitle: "Remedy",
        artist: "The Black Crowes",
        set: 2,
        songNumber: 8,
        imageUrl: "__ia_thumb-8.jpg",
        description: ""
    }, {
        id: 16,
        songTitle: "If You Could Only See",
        artist: "Tonic",
        set: 2,
        songNumber: 7,
        imageUrl: "__ia_thumb-4.jpg",
        description: ""
    }, {
        id: 15,
        songTitle: "Figure it Out",
        artist: "Royal Blood",
        set: 2,
        songNumber: 5,
        imageUrl: "__ia_thumb-1.jpg",
        description: ""
    }, {
        id: 14,
        songTitle: "Got My Mojo Working",
        artist: "Muddy Waters",
        set: 2,
        songNumber: 4,
        imageUrl: "__ia_thumb-3.jpg",
        description: ""
    }, {
        id: 13,
        songTitle: "Human",
        artist: "Rag n' Bone Man",
        set: 2,
        songNumber: 2,
        imageUrl: "mbid-d83d2469-d6a8-4a60-9224-9a396d3e234f-16301898956_thumb250.jpg",
        description: ""
    }, {
        id: 12,
        songTitle: "Are You Gonna Go My Way",
        artist: "Lenny Kravitz",
        set: 2,
        songNumber: 1,
        imageUrl: "mbid-6f516fac-cffb-4313-a111-9fc2fae30bc5-10925811921_thumb250.jpg",
        description: ""
    }, {
        id: 11,
        songTitle: "Money City Maniacs",
        artist: "Sloan",
        set: 1,
        songNumber: 12,
        imageUrl: "__ia_thumb-6.jpg",
        description: ""
    }, {
        id: 10,
        songTitle: "Hey, Hey, What Can I Do",
        artist: "Led Zepplin",
        set: 1,
        songNumber: 11,
        imageUrl: "mbid-bf1e26a8-12b3-3f36-86b7-9d3c7bdd7490-11873441560_thumb250.jpg",
        description: ""
    }, {
        id: 9,
        songTitle: "Mr. Cab Driver",
        artist: "Lenny Kravitz",
        set: 1,
        songNumber: 10,
        imageUrl: "mbid-e514521d-40bf-3ed2-aee8-1fbf5326aa96-7080979628_thumb250.jpg",
        description: ""
    }, {
        id: 8,
        songTitle: "Rehab",
        artist: "Amy Winehouse",
        set: 1,
        songNumber: 9,
        imageUrl: "__ia_thumb-15.jpg",
        description: ""
    }, {        
        id: 7,
        songTitle: "Revolution",
        artist: "The Beatles",
        set: 1,
        songNumber: 8,
        imageUrl: "__ia_thumb-9.jpg",
        description: ""
    }, {
        id: 6,
        songTitle: "3 AM",
        artist: "Matchbox 20",
        set: 1,
        songNumber: 7,
        imageUrl: "mbid-cf3a0e74-9816-48b3-bd25-7f5dbd26c392-20476869488_thumb250.jpg",
        description: ""
    }, {
        id: 5,
        songTitle: "Sharp Dressed Man",
        artist: "ZZ Top",
        set: 1,
        songNumber: 6,
        imageUrl: "mbid-ac85b905-13c2-48f6-8951-d45612205fc2-3352624595_thumb250.jpg",
        description: ""
    }, {
        id: 4,
        songTitle: "Harder to Breathe",
        artist: "Maroon 5",
        set: 1,
        songNumber: 5,
        imageUrl: "mbid-9adea766-5f40-3896-acff-a1027e62e7a3-6682539263_thumb250.jpg",
        description: ""
    }, {
        id: 3,
        songTitle: "Little Black Submarines",
        artist: "The Black Keys",
        set: 1,
        songNumber: 3,
        imageUrl: "__ia_thumb-5.jpg",
        description: ""
    }, {
        id: 2,
        songTitle: "Interstate Love Song",
        artist: "Stone Temple Pilots",
        set: 1,
        songNumber: 2,
        imageUrl: "mbid-a1c9cf07-a406-376b-85bd-c4168f1d2e36-1233423108_thumb250.jpg",
        description: ""
    }, {
        id: 1,
        songTitle: "All the Small Things",
        artist: "Blink-182",
        set: 1,
        songNumber: 1,
        imageUrl: "mbid-15e89935-10db-3067-a784-e52d2e51d3ec-4063606250_thumb250.jpg",
        description: ""
    },
]

export { getData }